import { useEffect, useState } from "react";
import { logoutService } from "../../../Services/auth";
import { Alert } from "../../../utils/alerts";
import { Navigate } from "react-router-dom";

const Logout = () => {
  const [loading, setLoading] = useState(true);
  const handleLogout = async () => {
    try {
       await logoutService();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Alert("متاسفم...!", "متاسفانه مشکلی از سمت سرور رخ داده", "error");
    }
  };
  useEffect(() => {
    handleLogout();
  }, []);

  return loading ? (
    <h1 className="text-center waiting_center">لطفا صبر کنید...</h1>
  ) : (
    <Navigate to="https://app.copysa.ir/" />
  );
};

export default Logout;
